export const biddingZones = [
  ["Albania", "AL"],
  ["Austria", "AT"],
  ["Belarus", "BY"],
  ["Belgium", "BE"],
  ["Bosnia and Herzegovina", "BA"],
  ["Bulgaria", "BG"],
  ["Croatia", "HR"],
  ["Cyprus", "CY"],
  ["Czechia", "CZ"],
  ["Denmark 1", "DK_1"],
  ["Denmark 2", "DK_2"],
  ["Estonia", "EE"],
  ["Finland", "FI"],
  ["France", "FR"],
  ["Georgia", "GE"],
  ["Germany & Luxembourg", "DE_LU"],
  ["Greece", "GR"],
  ["Hungary", "HU"],
  ["Iceland", "IS"],
  ["Ireland - SEM", "IE_SEM"],
  ["Italy Calabria", "IT_CALA"],
  ["Italy Centre North", "IT_CNOR"],
  ["Italy Centre South", "IT_CSUD"],
  ["Italy North", "IT_NORD"],
  ["Italy Sardinia - Saco AC", "IT_SACO_AC"],
  ["Italy Sardinia - Saco DC", "IT_SACO_DC"],
  ["Italy Sardinia", "IT_SARD"],
  ["Italy Sicily", "IT_SICI"],
  ["Italy South", "IT_SUD"],
  ["Kosovo", "XK"],
  ["Latvia", "LV"],
  ["Lithuania", "LT"],
  ["Malta", "MT"],
  ["Moldova", "MD"],
  ["Montenegro", "ME"],
  ["Netherlands", "NL"],
  ["North Macedonia", "MK"],
  ["Norway 1", "NO_1"],
  ["Norway 2", "NO_2"],
  ["Norway 3", "NO_3"],
  ["Norway 4", "NO_4"],
  ["Norway 5", "NO_5"],
  ["Poland", "PL"],
  ["Portugal", "PT"],
  ["Romania", "RO"],
  ["Russia", "RU"],
  ["Serbia", "RS"],
  ["Slovakia", "SK"],
  ["Slovenia", "SI"],
  ["Spain", "ES"],
  ["Sweden 1", "SE_1"],
  ["Sweden 2", "SE_2"],
  ["Sweden 3", "SE_3"],
  ["Sweden 4", "SE_4"],
  ["Switzerland", "CH"],
  ["Turkey", "TR"],
  ["Ukraine IPS", "UA_IPS"],
  ["United Kingdom", "GB"],
] as const satisfies [string, string][];
